import type { LucideProps } from 'lucide-react'

export const Down = (props: LucideProps) => {
	return (
		<svg
			width="8"
			height="6"
			viewBox="0 0 8 6"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<title>Down</title>
			<path
				d="M4 4L0 0H8L4 4Z"
				transform="translate(0,2)"
				fill="currentColor"
			/>
		</svg>
	)
}
